<template>
  <header id="header" class="topbar" v-if="user != null">
    <nav class="navbar top-navbar navbar-expand-md navbar-light">
      <div class="logo">
        <router-link class="navbar-brand" to="/">
          <span>
            <img
              src="@/assets/images/logo-light-text.png"
              class="light-logo"
              alt="homepage"
            />
          </span>
        </router-link>
      </div>
      <div class="navbar-collapse">
        <ul class="navbar-nav mr-auto mt-md-0">
          <li class="nav-item dropdown" :class="{ show: menuShow }">
            <a
              href="#mmenu"
              class="nav-link dropdown-toggle text-muted waves-effect waves-dark headTerm settingMenuButton"
              ><i class="mdi mdi-menu"></i
            ></a>
          </li>
          <!-- <li class="nav-item dropdown timeOut">
                <span class="nav-link">
                  <span>Kalan Süreniz: </span>
                  <span><span>{{timeOut.Day}}</span>:<span>{{timeOut.Hour}}</span>:<span>{{timeOut.Minute}}</span>:<span>{{timeOut.Second}}</span></span>
                </span>
              </li> -->
        </ul>
        <ul class="navbar-nav my-lg-0">
          <li class="nav-item dropdown">
            <a
              href="javascript:;"
              class="nav-link dropdown-toggle text-muted waves-effect waves-dark headTerm settingMenuButton"
              @click="setMuteAlarm(!muteAlarm)"
              ><i
                v-if="!muteAlarm"
                class="mdi mdi-volume-high mdi-volume-high"
              ></i
              ><i v-if="muteAlarm" class="mdi mdi-volume-off"></i
            ></a>
          </li>
          <li
            class="nav-item dropdown"
            :class="{ show: notificationShow }"
            @mouseleave="notificationShow = false"
          >
            <a
              class="nav-link dropdown-toggle text-muted text-muted waves-effect waves-dark"
              href="javascript:;"
              @click="notificationShow = !notificationShow"
            >
              <i class="mdi mdi-bell"></i>
              <div class="notify">
                <span class="heartbit"></span> <span class="point"></span>
              </div>
            </a>
            <div
              class="dropdown-menu dropdown-menu-right mailbox scale-up m-0"
              :class="{ show: notificationShow }"
            >
              <ul>
                <li>
                  <div class="drop-title">Bildirimler</div>
                </li>
                <li>
                  <div class="slimScrollDiv">
                    <div class="message-center">
                      <a href="#">
                        <div class="btn btn-info btn-circle">
                          <i class="mdi mdi-weather-sunset-down"></i>
                        </div>
                        <div class="mail-contnet p-l-10">
                          <h5>Kolayrez</h5>
                          <span class="mail-desc"
                            >3 yeni rezervasyon geldi.</span
                          >
                        </div>
                      </a>
                      <a href="#">
                        <div class="btn btn-danger btn-circle">
                          <i class="mdi mdi-trending-down"></i>
                        </div>
                        <div class="mail-contnet p-l-10">
                          <h5>Tourscope</h5>
                          <span class="mail-desc"
                            >Rakip otelinizin fiyatı değişti.</span
                          >
                        </div>
                      </a>
                      <a href="#">
                        <div class="btn btn-warning btn-circle">
                          <i class="mdi mdi-chart-gantt"></i>
                        </div>
                        <div class="mail-contnet p-l-10">
                          <h5>Kontejyan</h5>
                          <span class="mail-desc">Kontejanınız azaldı.</span>
                        </div>
                      </a>
                      <a href="#">
                        <div class="btn btn-danger btn-circle">
                          <i class="mdi mdi-weather-sunset-up"></i>
                        </div>
                        <div class="mail-contnet p-l-10">
                          <h5>Kolayrez</h5>
                          <span class="mail-desc"
                            >3 rezervasyon iptali geldi.</span
                          >
                        </div>
                      </a>
                      <a href="#">
                        <div class="btn btn-success btn-circle">
                          <i class="mdi mdi-trending-up"></i>
                        </div>
                        <div class="mail-contnet p-l-10">
                          <h5>Tourscope</h5>
                          <span class="mail-desc"
                            >Rakip otelinizin fiyatı değişti.</span
                          >
                        </div>
                      </a>
                      <a href="#">
                        <div class="btn btn-warning btn-circle">
                          <i class="mdi mdi-chart-gantt"></i>
                        </div>
                        <div class="mail-contnet p-l-10">
                          <h5>Kontejyan</h5>
                          <span class="mail-desc">Kontejanınız azaldı.</span>
                        </div>
                      </a>
                    </div>
                  </div>
                </li>
                <li>
                  <a class="nav-link text-center" href="javascript:void(0);">
                    <strong>Diğer bildirimler</strong></a
                  >
                </li>
              </ul>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a
              href="javascript:;"
              @click="logout()"
              class="nav-link dropdown-toggle text-muted waves-effect waves-dark headTerm settingMenuButton"
              ><i class="mdi mdi-power"></i
            ></a>
          </li>
          <!-- <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle text-muted waves-effect waves-dark" @click="$root._data.volume=!$root._data.volume" id="2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="mdi mdi-volume-high" :class="$root._data.volume?'mdi-volume-high':'mdi-volume-off'"></i>
                </a>
              </li> -->
          <!-- <li class="nav-item dropdown" :class="{'show':profileShow}" v-if="!loginSettings">
                <a class="nav-link dropdown-toggle text-muted waves-effect waves-dark profileMenuButton" @click="profileShow=!profileShow;" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img :src="'https://kolayrez.azurewebsites.net/UploadedFiles/'+user.Avatar" alt="user" class="profile-pic  profileMenuButton" /></a>
                <div class="dropdown-menu dropdown-menu-right scale-up" :class="{'show':profileShow}">
                  <ul class="dropdown-user">
                    <li>
                      <div class="dw-user-box">
                        <div class="u-img"><img :src="'https://kolayrez.azurewebsites.net/UploadedFiles/'+user.Avatar" alt="user"></div>
                        <div class="u-text">
                          <h4>{{user.Name}}</h4>
                          <p class="text-muted">{{user.Email}}</p><a @click="profilePopShow=true;profileShow=false;" class="btn btn-rounded btn-danger btn-sm">Profile Git</a>
                        </div>
                      </div>
                    </li>
                    <li role="separator" class="divider"></li>
                    <li><a @click="profilePopShow=true;profileShow=false;"><i class="ti-user"></i> Profilim</a></li>
                    <li role="separator" class="divider"></li>
                    <li><a @click="passwordPopShow=true;profileShow=false;"><i class="ti-lock"></i> Şifre Değiştir</a></li>
                    <li role="separator" class="divider"></li>
                    <li><a @click="logout();profileShow=false;"><i class="fa fa-power-off"></i> Çıkış Yap</a></li>
                  </ul>
                </div>
              </li> -->
        </ul>
      </div>
    </nav>
  </header>
  <aside id="headerTabs">
    <ul class="nav nav-tabs customtab" role="tablist">
      <li class="nav-item">
        <div class="nav-link" :class="{ active: $route.path == '/' }">
          <span @click="$router.push('/')">Home</span>
        </div>
      </li>
      <!-- <li class="nav-item"><a class="nav-link" href="#home2"><span>Home</span><i class="mdi mdi-close"></i></a></li>
          <li class="nav-item"><a class="nav-link" href="#home2"><span>Home</span><i class="mdi mdi-close"></i></a></li> -->
      <li
        v-for="(item, index) in tabs.components"
        :key="index"
        class="nav-item"
        draggable="true"
        @dragstart="dragItem = index"
        @drop="endDrag(index)"
        @dragover.prevent
        @dragenter.prevent
      >
        <div
          class="nav-link"
          :class="{ active: item.uid == tabs.selected && $route.path != '/' }"
        >
          <span
            @click="
              $store.state.tabs.selected = item.uid;
              setTabsClicked(true);
              $router.push(item.url);
            "
            >{{ item.title }}</span
          >
          <i @click="removeTabItem(item.uid)" class="mdi mdi-close"></i>
        </div>
      </li>
    </ul>
  </aside>
  <nav id="mmenu">
    <ul>
      <li><a href="/#/users" @click="menuShow = false">Users</a></li>
      <li><a href="/#/myHotels" @click="menuShow = false">My Hotels</a></li>
      <li v-if="user.UserType != 2">
        <a href="/#/accounts" @click="menuShow = false">Accounts</a>
      </li>
      <li><a href="/#/currencies" @click="menuShow = false">Currencies</a></li>
      <li><a href="/#/languages" @click="menuShow = false">Languages</a></li>
      <li><a href="/#/countries" @click="menuShow = false">Countries</a></li>
      <li><a href="/#/workers" @click="menuShow = false">Workers</a></li>
      <li><a href="/#/branchs" @click="menuShow = false">Branchs</a></li>
      <li><a href="/#/customers" @click="menuShow = false">Customer</a></li>
      <li><a href="/#/softwares" @click="menuShow = false">Softwares</a></li>
      <li>
        <a href="/#/destination/towns" @click="menuShow = false"
          >Destination Towns</a
        >
      </li>
      <li><a href="/#/hotels" @click="menuShow = false">Hotels</a></li>
      <li>
        <a href="/#/hotelGroups" @click="menuShow = false">Hotel Groups</a>
      </li>
      <li><a href="/#/operators" @click="menuShow = false">Operators</a></li>
      <li>
        <a href="/#/notifications" @click="menuShow = false">Notifications</a>
      </li>
      <li>
        <span>Kolayrez</span>
        <ul>
          <li>
            <a href="/#/reservations" @click="menuShow = false">Reservations</a>
          </li>
          <li>
            <a href="/#/kolayrez/providers" @click="menuShow = false"
              >Providers</a
            >
          </li>
          <li>
            <a href="/#/kolayrez/customerProviders" @click="menuShow = false"
              >Customer Providers</a
            >
          </li>
          <li>
            <a href="/#/checkUser" @click="menuShow = false"
              >Check User</a
            >
          </li>
          <li>
            <span>Match</span>
            <ul>
              <li>
                <a href="/#/kolayrez/match/country" @click="menuShow = false"
                  >Country</a
                >
              </li>
              <li>
                <a href="/#/kolayrez/match/currencies" @click="menuShow = false"
                  >Currencies</a
                >
              </li>
              <li>
                <a href="/#/kolayrez/match/markets" @click="menuShow = false"
                  >Markets</a
                >
              </li>
              <li>
                <a
                  href="/#/kolayrez/match/citizenships"
                  @click="menuShow = false"
                  >Citizenships</a
                >
              </li>
              <li>
                <a href="/#/kolayrez/match/hotelNames" @click="menuShow = false"
                  >Hotel Names</a
                >
              </li>
              <li>
                <a
                  href="/#/kolayrez/match/agencyOperators"
                  @click="menuShow = false"
                  >Agency Operators
                </a>
              </li>
            </ul>
          </li>
          <li>
            <a href="/#/kolayrez/scanErrors" @click="menuShow = false"
              >Scan errors</a
            >
          </li>
          <li>
            <a href="/#/kolayrez/PMSLogs" @click="menuShow = false">PMS Logs</a>
          </li>
          <li>
            <a
              href="/#/kolayrez/customerProvidersLogs"
              @click="menuShow = false"
              >Customer Providers Logs</a
            >
          </li>
          <li>
            <a href="/#/kolayrez/mails" @click="menuShow = false">Mails</a>
          </li>
          <li>
            <a href="/#/kolayrez/confirmedDocument" @click="menuShow = false">Confirmed Documents</a>
          </li>
          <li>
            <a href="/#/kolayrez/tempReservations" @click="menuShow = false"
              >Temp Reservations</a
            >
          </li>
          <li>
            <a href="/#/kolayrez/sednaReservationLogs" @click="menuShow = false"
              >Sedna Reservation Logs</a
            >
          </li>
        </ul>
      </li>
      <li>
        <span>ReSearch</span>
        <ul>
          <li><a href="/#/research/room/availibility">Room Availibility</a></li>
          <li>
            <a href="/#/research/providerBasedReservations"
              >Provider Based Reservations
            </a>
          </li>
          <li><a href="/#/research/improve1">Improve 1</a></li>
        </ul>
      </li>
      <li>
        <span>Tourscope</span>
        <ul>
          <li><a href="/#/tourscope/scans">Scans</a></li>
          <li><a href="/#/tourscope/local/scans">Local Scans</a></li>
          <li>
            <a href="/#/tourscope/departure/cities" @click="menuShow = false"
              >Departure Cities</a
            >
          </li>
          <li>
            <a href="/#/tourscope/operators" @click="menuShow = false"
              >Operators</a
            >
          </li>
          <li>
            <a
              href="/#/tourscope/operator/match/report"
              @click="menuShow = false"
              >Operator Match Report</a
            >
          </li>
          <li>
            <a href="/#/tourscope/operator/countries" @click="menuShow = false"
              >Operator Countries</a
            >
          </li>
          <li>
            <a
              href="/#/tourscope/operator/departure/cities"
              @click="menuShow = false"
              >Operator Departure Cities</a
            >
          </li>
          <li>
            <a href="/#/tourscope/operator/hotels" @click="menuShow = false"
              >Operator Hotels</a
            >
          </li>
          <li>
            <a href="/#/tourscope/searchMinPrices" @click="menuShow = false"
              >Search Min Prices</a
            >
          </li>
          <li>
            <a href="/#/tourscope/createListScanItems" @click="menuShow = false"
              >Create List Scan Items</a
            >
          </li>
          <li>
            <a href="/#/tourscope/scanErrors" @click="menuShow = false"
              >Scan Errors</a
            >
          </li>
        </ul>
      </li>
      <li>
        <span>Technicals</span>
        <ul>
          <li><a href="/#/technicals/squids">Squids</a></li>
          <li><a href="/#/technicals/queues">Queues</a></li>
          <li><a href="/#/technicals/mailWorkers">Mail Workers</a></li>
          <li><a href="/#/technicals/dedicatedProxies">Dedicated Proxies</a></li>
        </ul>
      </li>
    </ul>
  </nav>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "Header",
  props: [],
  data() {
    return {
      dragItem: null,
      notificationShow: false,
      timeOutDate: new Date().setDate(new Date().getDate() + 10),
      timeOut: {
        Day: 15,
        Hour: 0,
        Minute: 0,
        Second: 0,
      },
    };
  },
  created() {
    this.timeOutTimer();
  },
  methods: {
    ...mapMutations([
      "removeTabItem",
      "orderTabs",
      "setTabsClicked",
      "setMuteAlarm",
    ]),
    logout() {
      this.$store.commit("setUser", null);
      this.$router.push({ name: "Login" });
    },
    startDrag(evt, item) {
      this.dragItem = item;
    },
    endDrag(index) {
      if (this.dragItem != null) {
        this.orderTabs({ drag: this.dragItem, drop: index });
        this.dragItem = null;
      }
    },
    timeOutTimer() {
      setInterval(() => {
        let dateDifference = this.timeOutDate - new Date();
        this.timeOut.Day = Math.floor(dateDifference / (1000 * 60 * 60 * 24));
        this.timeOut.Day =
          this.timeOut.Day.toString().length == 1
            ? "0" + this.timeOut.Day
            : this.timeOut.Day;
        this.timeOut.Hour = Math.floor(
          (dateDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        this.timeOut.Hour =
          this.timeOut.Hour.toString().length == 1
            ? "0" + this.timeOut.Hour
            : this.timeOut.Hour;
        this.timeOut.Minute = Math.floor(
          (dateDifference % (1000 * 60 * 60)) / (1000 * 60)
        );
        this.timeOut.Minute =
          this.timeOut.Minute.toString().length == 1
            ? "0" + this.timeOut.Minute
            : this.timeOut.Minute;
        this.timeOut.Second = Math.floor((dateDifference % (1000 * 60)) / 1000);
        this.timeOut.Second =
          this.timeOut.Second.toString().length == 1
            ? "0" + this.timeOut.Second
            : this.timeOut.Second;
      }, 1000);
    },
  },
  computed: {
    ...mapState(["user", "tabs", "muteAlarm"]),
  },
};
</script>
<style scoped></style>
